export default function Services() {
  const services = [
    {
      title: "Bookkeeping",
      description: "We keep your financial records complete, accurate, and up to date at all times.",
      color: "ocean-mid",
      imageSrc: "https://public.readdy.ai/ai/img_res/dd198ee7a954408cf443dab14baac7ad.jpg",
    },
    {
      title: "VAT Filing & Review",
      description: "We prepare and submit your VAT declarations accurately and on time.",
      color: "sunset-coral",
      imageSrc: "https://readdy.ai/api/search-image?query=tax%20filing%20documents%20and%20VAT%20declaration%20forms%20neatly%20arranged%20on%20a%20desk%20accountant%20reviewing%20official%20tax%20papers%20with%20a%20pen%20calendar%20showing%20deadline%20clean%20minimal%20office%20background%20professional%20and%20compliant%20atmosphere%20warm%20neutral%20tones%20organized%20paperwork&width=600&height=350&seq=svc-vat-002&orientation=landscape",
    },
    {
      title: "Financial Control",
      description: "We reconcile and review your financial records to ensure consistent and reliable reporting.",
      color: "ocean-mid",
      imageSrc: "https://readdy.ai/api/search-image?query=financial%20analyst%20reviewing%20balance%20sheet%20and%20profit%20loss%20statement%20on%20a%20large%20monitor%20reconciliation%20spreadsheets%20open%20clean%20modern%20office%20desk%20precise%20and%20structured%20data%20visible%20on%20screen%20minimal%20white%20background%20professional%20control%20and%20accuracy%20atmosphere%20soft%20warm%20lighting&width=600&height=350&seq=svc-fincontrol-003&orientation=landscape",
    },
    {
      title: "Financial Accounting Support",
      description: "We support your CIT preparation, annual reports, and financial reporting processes.",
      color: "sunset-coral",
      imageSrc: "https://readdy.ai/api/search-image?query=corporate%20accountant%20preparing%20annual%20financial%20report%20and%20income%20tax%20documents%20at%20a%20tidy%20desk%20stacked%20official%20reports%20and%20binders%20laptop%20with%20financial%20data%20clean%20minimal%20office%20background%20professional%20support%20atmosphere%20warm%20neutral%20tones%20organized%20and%20structured%20setting&width=600&height=350&seq=svc-accounting-004&orientation=landscape",
    },
    {
      title: "Accounts Payable & Receivable",
      description: "We manage your AP and AR processes to keep your cash flow organised and under control.",
      color: "ocean-mid",
      imageSrc: "https://readdy.ai/api/search-image?query=finance%20professional%20processing%20invoices%20and%20payment%20follow-ups%20on%20a%20computer%20screen%20accounts%20payable%20and%20receivable%20documents%20on%20desk%20organized%20cash%20flow%20management%20visual%20clean%20minimal%20office%20background%20professional%20and%20efficient%20atmosphere%20warm%20neutral%20tones%20structured%20workflow&width=600&height=350&seq=svc-apar-005&orientation=landscape",
    },
    {
      title: "Bank Monitoring & Payment Processing",
      description: "We monitor your bank activity and support payment processing for smooth financial operations.",
      color: "sunset-coral",
      imageSrc: "https://readdy.ai/api/search-image?query=financial%20professional%20monitoring%20bank%20transactions%20and%20payment%20processing%20on%20dual%20screens%20bank%20statements%20and%20payment%20records%20visible%20secure%20and%20professional%20office%20environment%20clean%20minimal%20background%20trust%20and%20accuracy%20atmosphere%20warm%20neutral%20tones%20modern%20banking%20workflow&width=600&height=350&seq=svc-bank-006&orientation=landscape",
    },
  ];

  const gradientMap: Record<string, string> = {
    "ocean-mid": "from-ocean-mid/70 via-ocean-mid/10 to-transparent",
    "sunset-coral": "from-sunset-coral/70 via-sunset-coral/10 to-transparent",
  };

  const borderMap: Record<string, string> = {
    "ocean-mid": "border-ocean-mid/15",
    "sunset-coral": "border-sunset-coral/15",
  };

  return (
    <section id="services" style={{ scrollMarginTop: '80px', backgroundColor: '#ffffff' }} className="pt-20 pb-20 px-6 min-h-screen">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-ocean-mid/10 to-sunset-coral/10 px-3 py-1 rounded-full mb-3 border border-ocean-mid/20">
            <i className="ri-service-line text-ocean-mid text-xs"></i>
            <span className="text-[10px] font-semibold text-ocean-mid uppercase tracking-wide">Services</span>
          </div>
          <h4>
            <a href="#services" className="text-xl md:text-2xl font-bold text-ocean-mid font-serif">
              BB Global Financial Administration
            </a>
          </h4>
          <p className="text-[11px] text-gray-700 mt-2 max-w-2xl mx-auto">
            Tailored services designed to streamline your financial operations and support your business growth
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl overflow-hidden shadow-lg border ${borderMap[service.color]} hover:shadow-xl transition-all duration-300`}
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={service.imageSrc}
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${gradientMap[service.color]}`}></div>
                <div className="absolute bottom-3 left-4">
                  <span className="text-white text-sm font-bold font-serif drop-shadow">{service.title}</span>
                </div>
              </div>
              <div className="px-4 py-3">
                <p className="text-xs text-gray-700 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-[11px] text-gray-500 mt-6 max-w-2xl mx-auto italic">
          All activities are provided as financial support and assistance, helping companies maintain accurate financial administration and well-structured reporting processes.
        </p>
      </div>
    </section>
  );
}
